import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-the-page-m04__form c-form-inner" }
const _hoisted_2 = { class: "p-form-group" }
const _hoisted_3 = { class: "p-form-group" }
const _hoisted_4 = { class: "p-form-group" }
const _hoisted_5 = { class: "p-form-group" }
const _hoisted_6 = { class: "p-form-group" }
const _hoisted_7 = { class: "p-form-group" }
const _hoisted_8 = { class: "p-form-group" }
const _hoisted_9 = { class: "p-form-button-group" }
const _hoisted_10 = { class: "p-form-button-group__vertical" }
const _hoisted_11 = { class: "p-form-button-group__vertical" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormLabel = _resolveComponent("FormLabel")!
  const _component_FormUneditableText = _resolveComponent("FormUneditableText")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FormZipcode = _resolveComponent("FormZipcode")!
  const _component_ValidationErrorText = _resolveComponent("ValidationErrorText")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_TheTemplateM = _resolveComponent("TheTemplateM")!

  return (_openBlock(), _createBlock(_component_TheTemplateM, { class: "p-the-page-m04" }, {
    heading: _withCtx(() => _cache[7] || (_cache[7] = [
      _createTextVNode("個人情報登録", -1)
    ])),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.loaded)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              ref: "form",
              action: "/my-page/",
              method: "put",
              onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.handleSubmit(_ctx.onSubmit)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_FormLabel, { required: true }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("名前", -1)
                  ])),
                  _: 1,
                  __: [8]
                }),
                _createVNode(_component_FormUneditableText, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.name), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_FormLabel, {
                  for: "zipcode",
                  required: true
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("郵便番号", -1)
                  ])),
                  _: 1,
                  __: [9]
                }),
                _createVNode(_component_FormZipcode, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      id: "zipcode",
                      modelValue: _ctx.fields.zipcode.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fields.zipcode.value) = $event)),
                      type: "tel",
                      name: "zipcode",
                      error: _ctx.fields.zipcode.errorMessage,
                      placeholder: "0000000",
                      autocomplete: "postal-code",
                      maxlength: "8"
                    }, null, 8, ["modelValue", "error"])
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_ValidationErrorText, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.fields.zipcode.errorMessage), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.fields.zipcode.errorMessage]
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_FormLabel, {
                  for: "pref",
                  required: true
                }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode("都道府県名", -1)
                  ])),
                  _: 1,
                  __: [10]
                }),
                _createVNode(_component_InputSelect, {
                  id: "pref",
                  modelValue: _ctx.fields.pref.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fields.pref.value) = $event)),
                  name: "pref",
                  error: _ctx.fields.pref.errorMessage,
                  options: _ctx.prefOptions,
                  class: "p-the-page-m04__pref",
                  autocomplete: "address-level1"
                }, null, 8, ["modelValue", "error", "options"]),
                _withDirectives(_createVNode(_component_ValidationErrorText, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.fields.pref.errorMessage), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.fields.pref.errorMessage]
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_FormLabel, {
                  for: "address3",
                  required: true
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode("市町村区", -1)
                  ])),
                  _: 1,
                  __: [11]
                }),
                _createVNode(_component_InputText, {
                  id: "address3",
                  modelValue: _ctx.fields.address3.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fields.address3.value) = $event)),
                  type: "text",
                  name: "address3",
                  error: _ctx.fields.address3.errorMessage,
                  autocomplete: "address-level2"
                }, null, 8, ["modelValue", "error"]),
                _withDirectives(_createVNode(_component_ValidationErrorText, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.fields.address3.errorMessage), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.fields.address3.errorMessage]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_FormLabel, {
                  for: "address1",
                  required: true
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode("番地", -1)
                  ])),
                  _: 1,
                  __: [12]
                }),
                _createVNode(_component_InputText, {
                  id: "address1",
                  modelValue: _ctx.fields.address1.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fields.address1.value) = $event)),
                  type: "text",
                  name: "address1",
                  error: _ctx.fields.address1.errorMessage,
                  autocomplete: "address-level3"
                }, null, 8, ["modelValue", "error"]),
                _withDirectives(_createVNode(_component_ValidationErrorText, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.fields.address1.errorMessage), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.fields.address1.errorMessage]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_FormLabel, { for: "address2" }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("建物名・部屋番号", -1)
                  ])),
                  _: 1,
                  __: [13]
                }),
                _createVNode(_component_InputText, {
                  id: "address2",
                  modelValue: _ctx.fields.address2.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fields.address2.value) = $event)),
                  type: "text",
                  name: "address2",
                  error: _ctx.fields.address2.errorMessage,
                  autocomplete: "address-level4"
                }, null, 8, ["modelValue", "error"]),
                _withDirectives(_createVNode(_component_ValidationErrorText, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.fields.address2.errorMessage), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.fields.address2.errorMessage]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_FormLabel, {
                  for: "telephone",
                  required: true
                }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                    _createTextVNode("電話番号", -1)
                  ])),
                  _: 1,
                  __: [14]
                }),
                _createVNode(_component_InputText, {
                  id: "telephone",
                  modelValue: _ctx.fields.telephone.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fields.telephone.value) = $event)),
                  type: "tel",
                  name: "telephone",
                  error: _ctx.fields.telephone.errorMessage,
                  autocomplete: "tel"
                }, null, 8, ["modelValue", "error"]),
                _withDirectives(_createVNode(_component_ValidationErrorText, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.fields.telephone.errorMessage), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.fields.telephone.errorMessage]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_ButtonMain, {
                    type: "submit",
                    disabled: !_ctx.meta.valid,
                    onClickButton: _ctx.submitAddress
                  }, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createTextVNode(" 登録 ", -1)
                    ])),
                    _: 1,
                    __: [15]
                  }, 8, ["disabled", "onClickButton"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_ButtonMain, {
                    tag: 'a',
                    href: "/my-page/",
                    kind: 'cancel'
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode(" キャンセル ", -1)
                    ])),
                    _: 1,
                    __: [16]
                  })
                ])
              ])
            ], 544))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}